import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'pop-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.less']
})
export class SelectComponent {
  @Input()
  public keyField?: string;

  @Input()
  public labelField?: string;

  @Input()
  public disabled?: boolean;

  @Input()
  public options?: Object[];

  @Input() public disableEmptyOption = false;

  private _selectedOption: string | undefined;
  @Input() public get selectedOption() {
    return this._selectedOption;
  }
  public set selectedOption(value: string | undefined) {
    this._selectedOption = value;
    this.selectedOptionChange.emit(value);
  }

  @Output() public selectedOptionChange = new EventEmitter<string | undefined>();

  public getLabel(option: Object) {
    if (this.labelField) {
      return option[this.labelField];
    }
    if (typeof option === 'string') {
      return option;
    }
    return '';
  }
}
